export const REGEX = {
  PERSONALNUMBER: /^\d{8}$/,
  HAS_LOWERCASE: /(?=.*[a-z])/,
  HAS_UPPERCASE: /(?=.*[A-Z])/,
  HAS_NUMBER: /(?=\d+)/,
  HAS_SPECIAL: /[^a-zA-Z0-9]/,
  INPUT_IMAGE: /image\/(jpeg|png)/,
  INPUT_PDF: /.*.pdf/,
};
